import { ThemeEvents } from '@theme/events';

const OVERFLOW_FORM_PATTERN = /-overflow$/;
const SORT_ONLY_FORM_PATTERN = /-whyshift-mobile-sort$|-desktop$/;

/**
 * Merge partial facet form data with active params from the current URL.
 *
 * @param {FormData} formData
 * @param {HTMLFormElement} formEl
 * @returns {URLSearchParams | null} null = use default FacetsFormComponent behavior
 */
function mergeFormWithCurrentUrl(formData, formEl) {
  if (OVERFLOW_FORM_PATTERN.test(formEl.id)) {
    return null;
  }

  const merged = new URLSearchParams();
  const current = new URL(window.location.href).searchParams;
  const isSortOnly = SORT_ONLY_FORM_PATTERN.test(formEl.id);

  for (const [key, value] of current.entries()) {
    if (key.startsWith('filter.') || key === 'q') {
      merged.append(key, value);
    }
  }

  for (const [key, value] of formData.entries()) {
    if (key === 'page') continue;

    if (key === 'sort_by') {
      merged.delete('sort_by');
      if (value !== '') merged.set('sort_by', value);
      continue;
    }

    if (key.startsWith('filter.')) {
      if (isSortOnly) continue;

      merged.delete(key);
      if (value !== '') merged.append(key, value);
    }
  }

  const sortBy = formData.get('sort_by');
  if (typeof sortBy === 'string' && sortBy !== '') {
    merged.set('sort_by', sortBy);
  } else if (current.get('sort_by')) {
    merged.set('sort_by', current.get('sort_by'));
  }

  if (merged.get('filter.v.price.gte') === '') merged.delete('filter.v.price.gte');
  if (merged.get('filter.v.price.lte') === '') merged.delete('filter.v.price.lte');

  merged.delete('page');

  const searchQuery = current.get('q');
  if (searchQuery) merged.set('q', searchQuery);

  return merged;
}

/**
 * @param {HTMLElement} section
 */
function patchWhyshiftCollectionFacets(section) {
  section.querySelectorAll('facets-form-component').forEach((component) => {
    const form = component.querySelector('form[ref="facetsForm"]');
    if (!(form instanceof HTMLFormElement)) return;

    if (component.dataset.whyshiftFacetsPatched === 'true') return;
    component.dataset.whyshiftFacetsPatched = 'true';

    const originalCreateURLParameters = component.createURLParameters.bind(component);

    component.createURLParameters = function createURLParameters(formData) {
      const data = formData ?? new FormData(this.refs.facetsForm);
      const merged = mergeFormWithCurrentUrl(data, this.refs.facetsForm);

      if (merged) return merged;

      return originalCreateURLParameters(data);
    };
  });
}

function patchAllWhyshiftCollections() {
  document.querySelectorAll('.whyshift-collection').forEach(patchWhyshiftCollectionFacets);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', patchAllWhyshiftCollections);
} else {
  patchAllWhyshiftCollections();
}

document.addEventListener(ThemeEvents.FilterUpdate, () => {
  requestAnimationFrame(patchAllWhyshiftCollections);
});
